<ces-asset-breadcrumb [trail]="breadcrumbTrail()" />

<div class="p-(--padding-card) pt-(--space-2)" [attr.aria-busy]="submitting ? true : null">
  <div class="mb-(--space-4) flex justify-between items-center">
    <h1 class="text-h1">{{ getTitle() }}</h1>
  </div>

  <span role="status" class="sr-only" aria-live="polite">
    @if (submitting) {
      {{ 'common.loading.saving' | transloco }}
    }
  </span>

  <ces-wizard-stepper
    [stepsItems]="stepsItems"
    [activeStepIndex]="activeStepIndex()"
    [isCurrentStepValid]="isCurrentStepValid()"
    [submitting]="submitting"
    (previousStepClick)="previousStep()"
    (nextStepClick)="nextStep()"
    (submitClick)="submitForm()" />

  <div class="mt-(--space-8)">
    @if (activeStepIndex() === 0) {
      <app-automatic-measure-info [parentForm]="infoGroup" [assetId]="currentAssetId" [existingNames]="existingNamesOnAsset()" />
    }

    @if (activeStepIndex() === 1) {
      <app-manual-measure-formula
        [parentForm]="formulaGroup"
        [units]="unitStore.entities()"
        [measures]="measuresForAsset()"
        [lockedFirstParameter]="true"
        [forbiddenExtraTypes]="forbiddenExtraParameterTypes"
        [allowedParameterTypes]="allowedParameterTypes"
        [historicalFunctionsAvailable]="false"
        [includeAcquisitionType]="true" />
    }

    @if (activeStepIndex() === 2) {
      <app-manual-measure-verification
        [parentForm]="verificationGroup"
        [units]="unitStore.entities()"
        [measures]="measuresForAsset()" />
    }
  </div>
</div>
